import posthog from "posthog-js"
import type { Platform } from "@/shared/lib/platform"
import { initializeTelegramSDK } from "@/shared/lib/telegram"

// Telegram viewport/safe-area. A failure here must not kill the boot and leave
// a blank screen. Native system bars take their style from capacitor.config.ts.
export async function initSystemChrome(platform: Platform): Promise<void> {
	if (platform === "telegram") {
		try {
			await initializeTelegramSDK()
		} catch (error) {
			posthog.captureException(error, { scope: "boot.telegramSdk" })
		}
	}
}
